import { http } from '../../../services/apiProductWarranty/Http.interceptor';
import { ResponseProduct } from "../interfaces/ResponseProduct";

interface ProductWarranty {
  codigo: number;
  loja: String;
}

const URL: string = '/';

export const getProductDetails = (product: ProductWarranty) => {
  return http.post<ResponseProduct[]>(URL, product);
}
